import { Box, Container, StepLabel, styled } from '@mui/material';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';

export const StepperContainer = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StepperHeader = styled(Container)<{ padding?: string }>(
  ({ padding }) => ({
    height: 'auto',
    maxWidth: '100%',
    padding: padding || '40px 60px',
  }),
);

export const StyledStepConnector = styled(StepConnector)(
  ({ theme, $borderStyle }) => `
color: ${theme.palette.brand.darkGrey};
& .${stepConnectorClasses.alternativeLabel} {
    color: ${theme.palette.brand.darkGrey};
  }

    &.${stepConnectorClasses.alternativeLabel} {
  color: ${theme.palette.brand.darkGrey};
}
& .${stepConnectorClasses.active} {
  & .${stepConnectorClasses.line} {
    border-color: ${theme.palette.brand.blue};
  }
}
& .${stepConnectorClasses.completed} {
  & .${stepConnectorClasses.line} {
    border-color: ${theme.palette.brand.blue};
  };
}
& .${stepConnectorClasses.line} {
   border-style: ${$borderStyle};
   border-width: 1px;
}
`,
);

export const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',

  '& .MuiStepLabel-label': {
    color: theme.palette.brand.darkGrey,
    marginTop: 8,
  },

  '& .MuiStepLabel-iconContainer': {
    paddingRight: 8,
  },

  '& .MuiStepLabel-label.Mui-completed': {
    color: theme.palette.brand.black,
  },

  '& .Mui-active.MuiStepLabel-alternativeLabel': {
    color: theme.palette.brand.black,
  },
  '& .MuiStepLabel-label.Mui-active': {
    color: theme.palette.brand.black,
  },
}));
